import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  "NAME": (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};



const duck = createDuck("REGISTRO", newActions, newReducers);

const registroThunk = (data) => {
  const url = `${baseUrl}/v2/registro`;
  return createThunk(axios, "post", duck.actions, url, data);
};



const duckUsuario = createDuck("USUARIO", newActions, newReducers);

const usuarioThunk = (credencial) => {
  const url = `${baseUrl}/usuario/credencial/${credencial}`;
  return createThunk(axios, "get", duckUsuario.actions, url, null);
};



const duckOrganizacion = createDuck("ORGANIZACIONBYID", newActions, newReducers);

const organizacionByIdThunk = (id) => {
  const url = `${baseUrl}/v2/getLocalById`;
  return createThunk(axios, "post", duckOrganizacion.actions, url, {id:id});
};



const duckInvitacion = createDuck("INVITACION", newActions, newReducers);

const getInvitacionBytokenthunk = (token) => {
  const url = `${baseUrl}/invitacionByToken/${token}`;
  return createThunk(axios, "get", duckInvitacion.actions, url, null);
};



const duckCrearAutoInvitacion = createDuck("AUTOINVITACION_CREAR", newActions, newReducers);

const crearAutoInvitacionThunk = (data) => {
  const url = `${baseUrl}/crearAutoInvitacion/`;
  return createThunk(axios, "post", duckCrearAutoInvitacion.actions, url, data);
};



export default {
  duck,
  registroThunk,
  duckUsuario,
  usuarioThunk,  
  duckOrganizacion,
  organizacionByIdThunk,
  duckInvitacion,
  getInvitacionBytokenthunk,
  duckCrearAutoInvitacion,
  crearAutoInvitacionThunk,
};
